import {useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {isOnlineBookingModuleDisabled} from "../utils/checkOnlineBookingModule";

/**
 * Checks Online Booking module availability before protected navigation.
 * The module is enabled/disabled at the company level for all branches.
 *
 * If the module is explicitly inactive, redirects to the company branch list route
 * with onlineBookingUnavailable state, so BranchList can render BookingUnavailableNotice.
 *
 * Module not found / unknown status / network error are NOT treated as unavailability —
 * the user is not blocked in these cases.
 */

export const useOnlineBookingAvailabilityGuard = () => {
    const navigate = useNavigate();
    const {companyId} = useParams();
    const [checking, setChecking] = useState(false);
    const inFlight = useRef(false);

    const guardNavigate = async (onAllowed) => {
        if (inFlight.current) return;
        inFlight.current = true;
        setChecking(true);
        try {
            const disabled = await isOnlineBookingModuleDisabled(companyId);
            if (disabled) {
                navigate(`/company/${companyId}`, {state: {onlineBookingUnavailable: true}});
            } else {
                onAllowed?.();
            }
        } finally {
            inFlight.current = false;
            setChecking(false);
        }
    };

    return {guardNavigate, checking};
};
